module.exports = __webpack_public_path__ + "static/media/decline-proj-req.812ce707.svg";